/**
 * orga-app-api - einlasskontrolle-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EinlasskontrolleRolleOptionenRequest { 
    ist_aktiv?: boolean;
    ist_protokollierung_aktiv?: boolean;
    rolle_id: string;
    funktionsbereich_id: string;
}

